module.exports = __webpack_public_path__ + "53e8513ce20d507ebe8d1b86cd22e345.webp";